











import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { toastMixin } from '@/Shared/CommonEntityMixins/ToastMixin';
import { HostedCheckoutRequestVantiv, VantivIFrameConfig } from '@/Payment/HostedCheckoutRequestVantiv';
import Vue from 'vue';
import VatsAPI from '@/Shared/VatsAPI';
import { IframeClientConfig } from './IFrameConfig';
import { IFrameResponse } from './IFrameResponse';
import jQuery from 'jquery';

// Moving this into its own file and importing it turned into a mess
declare class EprotectIframeClient {
    public constructor(config: IframeClientConfig);
    public autoAdjustHeight(): void;
    public getPaypageRegistrationId(msg: { id: string, orderId: string }): void;
}

declare global {
    interface Window {
        EprotectIframeClient?: EprotectIframeClient;
        jQuery: JQueryStatic;
    }
}

// Have to manually set it, because just importing the module doesn't.
// Vantiv's script requires jQueryStatic be in the global namespace.
window.jQuery = jQuery;

const component = mixins(LocationBasedMixin, toastMixin).extend({
    mounted() {
        if (!window.EprotectIframeClient) {
            const scriptDiv = this.$refs.scriptDiv as Element;
            const scriptLoader = document.createElement('script') as HTMLScriptElement;
            scriptLoader.src = this.hostedCheckout.scriptUrl;
            scriptLoader.onload = () => this.configureIFrame();
            scriptDiv.appendChild(scriptLoader);
        }
        else {
            this.configureIFrame();
        }
    },
    props: {
        hostedCheckout: {
            required: true,
            type: Object as () => HostedCheckoutRequestVantiv
        }
    },
    data() {
        return {
            client: null as EprotectIframeClient | null,
            loading: false,
            i18nPrefix: 'payment.paymentCompletion.vantiv',
            validationMessage: null as string | null,
        };
    },
    methods: {
        configureIFrame(): void {
            if (!window.EprotectIframeClient) {
                const titleKey = `${this.i18nPrefix}.unableToContactPaymentProcessorTitle`;
                const messageKey = `${this.i18nPrefix}.unableToContactPaymentProcessorMessage`;
                this.popupToast(titleKey, messageKey);
                return;
            }
            const iframeDiv = this.$refs.iframeDiv as Element;
            const config: IframeClientConfig = {
                ...this.hostedCheckout.config,
                callback: (response: IFrameResponse) => this.handleIFrameResponse(response),
                div: iframeDiv.id
            };
            this.client = new EprotectIframeClient(config);
            this.client.autoAdjustHeight();

            iframeDiv.scrollIntoView();
        },
        submit(): void {
            this.client?.getPaypageRegistrationId({
                id: this.hostedCheckout.merchantTransactionId,
                orderId: this.hostedCheckout.orderId
            });
        },
        async handleIFrameResponse(response: IFrameResponse) {
            this.validationMessage = null;
            const errorTitleKey = 'common.error';
            const validationResult = this.validateIFrameResponse(response);
            if (validationResult !== true) {
                this.popupToast(errorTitleKey, validationResult as string);
                this.validationMessage = this.$t(validationResult as string).toString();
                return;
            }

            this.loading = true;
            try {
                // this *should* be a redirect, but the browser automatically follows those silently
                // so instead we get the result of whatever's at the redirect url.
                // We can take the path of the redirected result and use that instead
                const result = await VatsAPI.post(this.hostedCheckout.responsePath, response);
                if (result.status === 200) {
                    // most backwards-compatible way to parse URLs into components
                    const parser = document.createElement('a');
                    parser.href = result.request.responseURL;

                    const locator = `${parser.pathname}${parser.search}${parser.hash}`;
                    this.$router.push(locator);
                }
                else {
                    throw new Error(`Unexpected result from server: ${result.status} - ${result.statusText}`);
                }
            }
            catch (e) {
                const titleKey = `${this.i18nPrefix}.paymentCompletionFailedTitle`;
                const messageKey = `${this.i18nPrefix}.paymentCompletionFailedMessage`;
                this.popupToast(titleKey, messageKey);

                throw e;
            }
            finally {
                this.loading = false;
            }
        },
        validateIFrameResponse(response: IFrameResponse): boolean | string {
            const messageKeyPrefix = `${this.i18nPrefix}.invalidCard`;
            if (response.response === '871') {
                return `${messageKeyPrefix}.mod10`;
            }
            else if (response.response === '872') {
                return `${messageKeyPrefix}.tooShort`;
            }
            else if (response.response === '873') {
                return `${messageKeyPrefix}.tooLong`;
            }
            else if (response.response === '874') {
                return `${messageKeyPrefix}.notANumber`;
            }
            else if (response.response === '875') {
                return `${messageKeyPrefix}.technicalDifficulties`;
            }
            else if (response.response === '876') {
                return `${messageKeyPrefix}.failureFromServer`;
            }
            else if (response.response === '881') {
                return `${messageKeyPrefix}.cvv.notANumber`;
            }
            else if (response.response === '882') {
                return `${messageKeyPrefix}.cvv.tooShort`;
            }
            else if (response.response === '883') {
                return `${messageKeyPrefix}.cvv.tooLong`;
            }
            else if (response.response === '889') {
                return `${messageKeyPrefix}.technicalDifficulties`;
            }
            return true;
        }
    }
});

export default component;
